import Counter from './index';
import React from 'react';

type ControlledCounterProps = {
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
};
function ControlledCounter({value, onChange, disabled}: ControlledCounterProps) {
  return (
    <Counter
      value={value}
      disabled={disabled}
      onDecrement={() => onChange(value - 1)}
      onIncrement={() => onChange(value + 1)}
    />
  );
}

export {ControlledCounter};
